export class InscricaoEstadual {
    public static InscricaoEstadualValid(Inscricao_Estadual: string, UF: string): boolean {

        UF = UF?.toUpperCase();
        let inscEst: string = Inscricao_Estadual?.replace(/[^\d]+/g, '');

        if (!inscEst || !UF) return false;

        let tam: number
        let primDigito: number;
        let seguDigito: number;
        let pesos = "43298765432";
        let soma: number;
        let i: number
        let p: number;
        let d: number;
        let modulo: number
        let resultado: number
        let somaAux: string
        let mult: number
        const dig8 = "/RJ*";
        const dig9 = "/AL*/AP*/AM*/BA*/CE*/ES*/GO*/MA*/MS*/PA*/PB*/PI*/RN*/RR*/SC*/SE*/TO*";
        const dig10 = "/PR*/RS*";
        const dig11 = "/MT*";
        const dig12 = "/SP*";
        const dig13 = "/AC*/MG*/DF*";
        const dig14 = "/PE*/RO*";

        if (dig8.indexOf("/" + UF + "*") != -1) {
            inscEst = inscEst.substring(0, 8);
            tam = 8;
        }
        if (dig9.indexOf("/" + UF + "*") != -1) {
            if (inscEst.length !== 9) return false; 
            tam = 9;
        }
        else if (dig10.indexOf("/" + UF + "*") != -1) {
            inscEst = inscEst.substring(0, 10);
            tam = 10;
        }
        else if (dig11.indexOf("/" + UF + "*") != -1) {
            inscEst = inscEst.substring(0, 11);
            tam = 11;
        }
        else if (dig12.indexOf("/" + UF + "*") != -1) {
            inscEst = inscEst.substring(0, 12);
            tam = 12;
        }
        else if (dig13.indexOf("/" + UF + "*") != -1) {
            inscEst = inscEst.substring(0, 13);
            tam = 13;
        }
        else if (dig14.indexOf("/" + UF + "*") != -1) {
            inscEst = inscEst.substring(0, 14);
            tam = 14;
        }
        else {
            inscEst = "";
            tam = 0;
        }
    
        switch (UF) {
            case "AC":
                inscEst = strzero(inscEst, 13);
                primDigito = 0;
                seguDigito = 0;
                pesos = "43298765432";
                soma = 0;

                for (i = 0; i < pesos.length; i++) {
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                }
                primDigito = 11 - (soma % 11);
                if (primDigito > 9)
                    primDigito = 0;
                pesos = "543298765432";
                soma = 0;
                for (i = 0; i < pesos.length; i++) {
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                }
                seguDigito = 11 - (soma % 11);
                if (seguDigito > 9)
                    seguDigito = 0;

                if ((parseInt(inscEst.substr(11, 1)) != primDigito) || (parseInt(inscEst.substr(12, 1)) != seguDigito)) {
                    return false;
                }
                return true;

            case "AL":
                inscEst = strzero(inscEst, 9);
                primDigito = 0;
                pesos = "98765432";
                soma = 0;
                for (i = 0; i < pesos.length; i++) {
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                }
                soma = soma * 10;
                primDigito = soma % 11;
                if (primDigito > 9)
                    primDigito = 0;
                if (parseInt(inscEst.substr(8, 1)) != primDigito) {
                    return false;
                }
                return true;

            case "AP":
                inscEst = strzero(inscEst, 9);
                if (inscEst.substr(0, 2) != "03") {
                    return false;
                }
                else {
                    if (parseFloat(inscEst.substr(0, 8)) < 3017000) {
                        p = 5;
                        d = 0;
                    }
                    else if (parseFloat(inscEst.substr(0, 8)) < 3019022) {
                        p = 9;
                        d = 1;
                    }
                    else {
                        p = 0;
                        d = 0;
                    }
                    primDigito = 0;
                    pesos = "98765432";
                    soma = p;
                    for (i = 0; i < pesos.length; i++) {
                        soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                    }
                    primDigito = 11 - (soma % 11);
                    if (primDigito == 10)
                        primDigito = 0;
                    else if (primDigito == 11)
                        primDigito = d;
                    if (parseInt(inscEst.substr(8, 1)) != primDigito) {
                        return false;
                    }
                    return true;
                }

            case "AM":
                inscEst = strzero(inscEst, 9);
                primDigito = 0;
                pesos = "98765432";
                soma = 0;
                for (i = 0; i < pesos.length; i++) {
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                }
                if (soma < 11)
                    primDigito = 11 - soma;
                else {
                    primDigito = soma % 11;
                    if (primDigito < 2)
                        primDigito = 0;
                    else
                        primDigito = 11 - primDigito;
                }
                if (parseInt(inscEst.substr(8, 1)) != primDigito) {
                    return false;
                }
                return true;
            case "BA":
                return validarInscricaoEstadualBahia(inscEst);
            case "CE":
                inscEst = strzero(inscEst, 9);
                primDigito = 0;
                pesos = "98765432";
                soma = 0;
                for (i = 0; i < pesos.length; i++) {
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                }
                primDigito = 11 - (soma % 11);
                if (primDigito > 9)
                    primDigito = 0;
                if (parseInt(inscEst.substr(8, 1)) != primDigito) {
                    return false;
                }
                return true;

            case "DF":
                inscEst = strzero(inscEst, 13);
                if (inscEst.substr(0, 2) != "07") {
                    return false;
                }
                else {
                    primDigito = 0;
                    seguDigito = 0;
                    pesos = "43298765432";
                    soma = 0;
                    for (i = 0; i < pesos.length; i++) {
                        soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                    }
                    primDigito = 11 - (soma % 11);
                    if (primDigito > 9)
                        primDigito = 0;
                    pesos = "543298765432";
                    soma = 0;
                    for (i = 0; i < pesos.length; i++) {
                        soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                    }
                    seguDigito = 11 - (soma % 11);
                    if (seguDigito > 9)
                        seguDigito = 0;

                    if ((parseInt(inscEst.substr(11, 1)) != primDigito) || (parseInt(inscEst.substr(12, 1)) != seguDigito)) {
                        return false;
                    }
                    return true;
                }

            case "ES":
                inscEst = strzero(inscEst, 9);
                primDigito = 0;
                pesos = "98765432";
                soma = 0;
                for (i = 0; i < pesos.length; i++) {
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                }
                primDigito = 11 - (soma % 11);
                if (primDigito > 9)
                    primDigito = 0;
                if (parseInt(inscEst.substr(8, 1)) != primDigito) {
                    return false;
                }
                return true;

            case "GO":
                inscEst = strzero(inscEst, 9);
                primDigito = 0;
                pesos = "98765432";
                soma = 0;
                for (i = 0; i < pesos.length; i++) {
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                }
                primDigito = 11 - (soma % 11);
                if (inscEst.substr(0, 8) == "11094402") {
                    if ((parseInt(inscEst.substr(8, 1)) != 0) && (parseInt(inscEst.substr(8, 1)) != 1)) {
                        return false;
                    }
                }
                else {
                    if (primDigito == 11)
                        primDigito = 0;
                    else if (primDigito == 10) {
                        if ((parseFloat(inscEst.substr(0, 8)) >= 10103105) && (parseFloat(inscEst.substr(0, 8)) <= 10119997))
                            primDigito = 1;
                        else
                            primDigito = 0;
                    }
                    if (parseInt(inscEst.substr(8, 1)) != primDigito) {
                        return false;
                    }
                    return true;
                }
                return false

            case "MA":
                inscEst = strzero(inscEst, 9);
                if (inscEst.substr(0, 2) != "12") {
                    return false;
                }
                else {
                    primDigito = 0;
                    pesos = "98765432";
                    soma = 0;
                    for (i = 0; i < pesos.length; i++) {
                        soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                    }
                    primDigito = 11 - (soma % 11);
                    if (primDigito > 9)
                        primDigito = 0;
                    if (parseInt(inscEst.substr(8, 1)) != primDigito) {
                        return false;
                    }
                    return true;
                }

            case "MT":
                inscEst = strzero(inscEst, 11);
                primDigito = 0;
                pesos = "3298765432";
                soma = 0;
                for (i = 0; i < pesos.length; i++) {
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                }
                primDigito = 11 - (soma % 11);
                if (primDigito > 9)
                    primDigito = 0;
                if (parseInt(inscEst.substr(10, 1)) != primDigito) {
                    return false;
                }
                return true;

            case "MS":
                inscEst = strzero(inscEst, 9);
                if (inscEst.substr(0, 2) != "28") {
                    return false;
                }
                else {
                    primDigito = 0;
                    pesos = "98765432";
                    soma = 0;
                    for (i = 0; i < pesos.length; i++) {
                        soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                    }
                    primDigito = 11 - (soma % 11);
                    if (primDigito > 9)
                        primDigito = 0;
                    if (parseInt(inscEst.substr(8, 1)) != primDigito) {
                        return false;
                    }
                    return true;
                }

            case "MG":
                inscEst = strzero(inscEst, 13);
                inscEst = inscEst.substr(0, 3) + "0" + inscEst.substr(3);
                primDigito = 0;
                seguDigito = 0;
                pesos = "121212121212";
                soma = 0;
                resultado = 0;
                for (i = 0; i < pesos.length; i++) {
                    resultado = parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1));
                    for (let j = 0; j < resultado.toString().length; j++) {
                        soma = soma + (parseInt(resultado.toString().substr(j, 1)));
                    }
                }
                somaAux = soma + "";
                primDigito = parseInt((parseInt(somaAux.substr(0, 1)) + 1) + "0") - soma;
                if (primDigito > 9)
                    primDigito = 0;
                inscEst = inscEst.substr(0, 3) + inscEst.substr(4);
                pesos = "321098765432";
                soma = 0;
                for (i = 0; i < pesos.length; i++) {
                    mult = parseInt(pesos.substr(i, 1));
                    if ((i > 1) && (i < 4))
                        mult = parseInt(pesos.substr(i, 1)) + 10;
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * mult);
                }
                seguDigito = 11 - (soma % 11);
                if (seguDigito > 9)
                    seguDigito = 0;

                if ((parseInt(inscEst.substr(11, 1)) != primDigito) || (parseInt(inscEst.substr(12, 1)) != seguDigito)) {
                    return false;
                }
                return true;
            case "PA":
                return validarInscricaoEstadualPara(inscEst);
            case "PB":
                inscEst = strzero(inscEst, 9);
                primDigito = 0;
                pesos = "98765432";
                soma = 0;
                for (i = 0; i < pesos.length; i++) {
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                }
                primDigito = 11 - (soma % 11);
                if (primDigito > 9)
                    primDigito = 0;
                if (parseInt(inscEst.substr(8, 1)) != primDigito) {
                    return false;
                }
                return true;

            case "PR":
                inscEst = strzero(inscEst, 10);
                primDigito = 0;
                seguDigito = 0;
                pesos = "32765432";
                soma = 0;
                for (i = 0; i < pesos.length; i++) {
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                }
                primDigito = 11 - (soma % 11);
                if (primDigito > 9)
                    primDigito = 0;
                pesos = "432765432";
                soma = 0;
                for (i = 0; i < pesos.length; i++) {
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                }
                seguDigito = 11 - (soma % 11);
                if (seguDigito > 9)
                    seguDigito = 0;

                if ((parseInt(inscEst.substr(8, 1)) != primDigito) || (parseInt(inscEst.substr(9, 1)) != seguDigito)) {
                    return false;
                }
                return true;

            case "PE":
                inscEst = strzero(inscEst, 14);
                primDigito = 0;
                pesos = "5432198765432";
                soma = 0;
                for (i = 0; i < pesos.length; i++) {
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                }
                primDigito = 11 - (soma % 11);
                if (primDigito > 9)
                    primDigito = primDigito - 10;
                if (parseInt(inscEst.substr(13, 1)) != primDigito) {
                    return false;
                }
                return true;

            case "PI":
                inscEst = strzero(inscEst, 9);
                primDigito = 0;
                pesos = "98765432";
                soma = 0;
                for (i = 0; i < pesos.length; i++) {
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                }
                primDigito = 11 - (soma % 11);
                if (primDigito > 9)
                    primDigito = 0;
                if (parseInt(inscEst.substr(8, 1)) != primDigito) {
                    return false;
                }
                return true;

            case "RJ":
                inscEst = strzero(inscEst, 8);
                primDigito = 0;
                pesos = "2765432";
                soma = 0;
                for (i = 0; i < pesos.length; i++) {
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                }
                primDigito = 11 - (soma % 11);
                if (primDigito > 9)
                    primDigito = 0;
                if (parseInt(inscEst.substr(7, 1)) != primDigito) {
                    return false;
                }
                return true;

            case "RN":
                inscEst = strzero(inscEst, 9);
                primDigito = 0;
                pesos = "98765432";
                soma = 0;
                for (i = 0; i < pesos.length; i++) {
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                }
                soma = soma * 10;
                primDigito = soma % 11;
                if (primDigito > 9)
                    primDigito = 0;
                if (parseInt(inscEst.substr(8, 1)) != primDigito) {
                    return false;
                }
                return true;

            case "RS":
                inscEst = strzero(inscEst, 10);
                primDigito = 0;
                pesos = "298765432";
                soma = 0;
                for (i = 0; i < pesos.length; i++) {
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                }
                primDigito = 11 - (soma % 11);
                if (primDigito > 9)
                    primDigito = 0;
                if (parseInt(inscEst.substr(9, 1)) != primDigito) {
                    return false;
                }
                return true;

            case "RO":
                inscEst = strzero(inscEst, 14);
                primDigito = 0;
                pesos = "6543298765432";
                soma = 0;
                for (i = 0; i < pesos.length; i++) {
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                }
                primDigito = 11 - (soma % 11);
                if (primDigito > 9)
                    primDigito -= 10;
                if (parseInt(inscEst.substr(13, 1)) != primDigito) {
                    return false;
                }
                return true;

            case "RR":
                inscEst = strzero(inscEst, 9);
                primDigito = 0;
                pesos = "12345678";
                soma = 0;
                for (i = 0; i < pesos.length; i++) {
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                }
                soma = soma * 10;
                primDigito = soma % 9;
                if (parseInt(inscEst.substr(8, 1)) != primDigito) {
                    return false;
                }
                return true;

            case "SC":
                inscEst = strzero(inscEst, 9);
                primDigito = 0;
                pesos = "98765432";
                soma = 0;
                for (i = 0; i < pesos.length; i++) {
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                }
                soma = soma * 10;
                primDigito = soma % 11;
                if (primDigito > 9)
                    primDigito = 0;
                if (parseInt(inscEst.substr(8, 1)) != primDigito) {
                    return false;
                }
                return true;

            case "SP":
                inscEst = strzero(inscEst, 12);
                primDigito = 0;
                seguDigito = 0;
                pesos = "13456780";
                soma = 0;
                for (i = 0; i < pesos.length; i++) {
                    mult = parseInt(pesos.substr(i, 1));
                    if (i == 7)
                        mult = 10;
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * mult);
                }
                primDigito = soma % 11;
                if (primDigito > 9)
                    primDigito = 0;
                pesos = "32098765432";
                soma = 0;
                for (i = 0; i < pesos.length; i++) {
                    mult = parseInt(pesos.substr(i, 1));
                    if (i == 2)
                        mult = 10;
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * mult);
                }
                seguDigito = soma % 11;
                if (seguDigito > 9)
                    seguDigito = 0;

                if ((parseInt(inscEst.substr(8, 1)) != primDigito) || (parseInt(inscEst.substr(11, 1)) != seguDigito)) {
                    return false;
                }
                return true;

            case "SE":
                inscEst = strzero(inscEst, 9);
                primDigito = 0;
                pesos = "98765432";
                soma = 0;
                for (i = 0; i < pesos.length; i++) {
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                }
                soma = soma * 10;
                primDigito = 11 - (soma % 11);
                if (primDigito > 9)
                    primDigito = 0;
                if (parseInt(inscEst.substr(8, 1)) != primDigito) {
                    return false;
                }
                return true;

            case "TO":
                inscEst = strzero(inscEst, 9); // 11 Se tiver 2 algarismos
                primDigito = 0;
                pesos = "98765432";
                soma = 0;
                for (i = 0; i < pesos.length; i++) {
                    soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
                }
                primDigito = 11 - (soma % 11);
                if (primDigito > 9)
                    primDigito = 0;
                if (parseInt(inscEst.substr(8, 1)) != primDigito) {
                    return false;
                }
                return true;
        }
        return false;
    }

    public static getMaxLength(uf: string): number {
    uf = uf.toUpperCase();

    const digitoPorUF: { [key: string]: number } = {
        'BA': 9,
        'PA': 9
    };

    return digitoPorUF[uf] || 0;
    }
}

function validarInscricaoEstadualBahia(ie: string): boolean {
    // Remove tudo que não for número
    const numerosLimpos = ie.replace(/\D/g, '');

    const numeros = numerosLimpos.split('').map(Number);
    const corpo = numeros.slice(0, 7); // primeiros 7 dígitos
    const dv1Informado = numeros[7];
    const dv2Informado = numeros[8];

    const segundoDigito = numeros[1];
    const usaModulo10 = [0, 1, 2, 3, 4, 5, 8].includes(segundoDigito);
    const modulo = usaModulo10 ? 10 : 11;

    // === Cálculo do 2º dígito verificador ===
    const pesos2 = [8, 7, 6, 5, 4, 3, 2];
    const soma2 = corpo.reduce((acc, num, idx) => acc + num * pesos2[idx], 0);
    const resto2 = soma2 % modulo;
    const dv2 = (modulo === 10)
    ? (resto2 === 0 ? 0 : modulo - resto2)
    : (resto2 === 0 || resto2 === 1 ? 0 : modulo - resto2);

    // === Cálculo do 1º dígito verificador ===
    const baseComDv2 = [...corpo, dv2];
    const pesos1 = [9, 8, 7, 6, 5, 4, 3, 2];
    const soma1 = baseComDv2.reduce((acc, num, idx) => acc + num * pesos1[idx], 0);
    const resto1 = soma1 % modulo;
    const dv1 = (modulo === 10)
    ? (resto1 === 0 ? 0 : modulo - resto1)
    : (resto1 === 0 || resto1 === 1 ? 0 : modulo - resto1);

    return dv1 === dv1Informado && dv2 === dv2Informado;
}

function validarInscricaoEstadualPara(ie: string): boolean {
    ie = strzero(ie, 9);
    const prefixo = ie.substr(0, 2);
    if (!["15", "75", "76", "77", "78", "79"].includes(prefixo)) {
        return false;
    }
    else {
        let soma = 0;
        const pesos = [9, 8, 7, 6, 5, 4, 3, 2];
        for (let i = 0; i < 8; i++) {
            soma += parseInt(ie[i]) * pesos[i];
        }
        let resto = soma % 11;
        let digito = resto === 0 || resto === 1 ? 0 : 11 - resto;

        return parseInt(ie[8]) === digito;
    }
}

function strzero(num: number | string, len: number) {
    let numberWithZeroes = String(num);
    let counter = numberWithZeroes.length;
    while (counter < len) {
        numberWithZeroes = "0" + numberWithZeroes;
        counter++;
    }
    return numberWithZeroes;
}
